import React from "react";
import MyNavbar from "../../../components/student/mynavbar/MyNavbar";
import NgoHero from "../../../screens/student/NgoScreen/NgoHero";
import NgoStates from "../../../screens/student/NgoScreen/NgoStates";
import NgoAbout from "../../../screens/student/NgoScreen/NgoAbout";
import HowItWorks from "./HowItWorks";
import CaseCategories from "./CaseCategories";
import NgoVerification from "./NgoVerification";
import BottomStats from "./BottomStates";
import Footer from "../../../components/student/footer/Footer";
const NGO=()=>{
    return(
        <div>
            <MyNavbar/>
            <NgoHero/>
            {/* <NgoStates/> */}
            <NgoAbout/>
            <HowItWorks/>
            <CaseCategories/>
            <NgoVerification/>
            <BottomStats/>
            <Footer/>


        </div>
    )

}
export default NGO;